/* eslint-disable @typescript-eslint/no-throw-literal */
import React from 'react';
import Page from 'components/misc/BasePage/Blog';
import ApiError from 'api/error';
import CategoryContent from 'pageContents/BlogContent/CategoryContent';
import BlogSubHeader from 'components/blog/BlogSubHeader';
import blogApi from 'entity/blog/blogApi';
import { Head } from 'components/blog/category';
import {
  ArticleCategoryApiResponse,
  GetArticlesByCategoryParams,
} from 'entity/blog/blogTypes';

interface OwnProps {
  categoryArticles: {
    articleResponse: ArticleCategoryApiResponse;
    articleParams: GetArticlesByCategoryParams;
  };
}

const Category = (props: OwnProps) => {
  const { categoryArticles } = props;
  return (
    <Page renderSubHeader={() => <BlogSubHeader />}>
      <Head category={categoryArticles.articleResponse.data.category} />
      <CategoryContent categoryArticles={categoryArticles} />
    </Page>
  );
};

Category.getInitialProps = async ({ query }) => {
  const { categorySlug } = query;
  const categoryParams = {
    orderBy: 'publishDate',
    slug: categorySlug,
    page: 1,
    perPage: 10,
  };
  const categoryResponse = await blogApi.getArticlesByCategory(categoryParams);

  if (!categoryResponse.ok) {
    const apiError = new ApiError(categoryResponse);
    throw apiError;
  }

  return {
    categoryArticles: {
      articleResponse: categoryResponse,
      articleParams: categoryParams,
    },
  };
};

export default Category;
